import { useQuery } from 'react-query';
import { API } from 'api';

export interface IEmploymentProfileListData {
  payload: {
    employeeName?: string;
    mobile?: string;
    eid?: string;
    employeeId?: string;
    idNumber?: string;
    status?: string;
    suspended?: string;
    suspensionTypes?: Array<string>;
    page: number;
  };
  data: {
    data: {
      id: string;
      uid: string;
      status: string;
      employeeId: string;
      idNo: string;
      mobile: string;
      name: string;
      salary: string;
      suspendedDate?: number | null;
      suspensionReasons?: { type: string; date: string; reason: string }[];
    }[];
    count: number;
  };
}

export const initEmploymentProfileListPayload: IEmploymentProfileListData['payload'] = {
  page: 1,
};

const getEmploymentProfileList = async (
  data: IEmploymentProfileListData['payload']
): Promise<IEmploymentProfileListData['data']> => {
  const params = new URLSearchParams();
  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => params.append(key, String(v)));
    } else if (value !== undefined && value !== null && value !== '') {
      params.append(key, String(value));
    }
  });
  const res = await API.newGet(`/api/admin/employment/profile/list?${params.toString()}`, {});
  return res.data;
};

export const useEmploymentProfileListData = (
  payload: IEmploymentProfileListData['payload'],
  options?: { enabled?: boolean }
) => {
  return useQuery(['employentProfiles', payload], () => getEmploymentProfileList(payload), {
    enabled: options?.enabled !== false,
    select: (data: IEmploymentProfileListData['data']) => {
      return data;
    },
  });
};
